/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /* ------------------------------------------------------------------------
     Header — pastille « nombre d'articles » sur l'icône panier
     Le thème ne rend aucun compteur dans le header : il se contente de
     poser/retirer la classe `.cart__toggle--has-items`. Le nombre initial est
     rendu par Liquid (sections/header.liquid, marqueurs CUSTOM) ; ce script le
     tient à jour après chaque action AJAX sur le panier.
     Source de vérité : /cart.js (item_count), interrogé (avec anti-rebond)
     - sur les événements du thème : theme:cart:added / loaded / refresh / update
     - à chaque re-rendu de la liste d'articles du tiroir panier (changement de
       quantité, retrait) via un MutationObserver sur [data-items-holder]
     - au retour sur la page depuis le cache navigateur (pageshow).
     ------------------------------------------------------------------------ */
  var BADGE_SELECTOR = '[data-custom-cart-count]';
  var refreshTimer = null;

  function cartJsUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'cart.js';
  }

  function renderCartCount(count) {
    document.querySelectorAll(BADGE_SELECTOR).forEach(function (badge) {
      badge.textContent = count;
      var toggle = badge.closest('.cart__toggle');
      if (toggle) {
        toggle.classList.toggle('cart__toggle--has-items', count > 0);
      }
    });
  }

  function refreshCartCount() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      fetch(cartJsUrl(), { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (cart) {
          if (cart && typeof cart.item_count === 'number') {
            renderCartCount(cart.item_count);
          }
        })
        .catch(function () { /* silencieux : on garde la valeur affichée */ });
    }, 250);
  }

  if (document.querySelector(BADGE_SELECTOR)) {
    ['theme:cart:added', 'theme:cart:loaded', 'theme:cart:refresh', 'theme:cart:update'].forEach(function (name) {
      document.addEventListener(name, refreshCartCount);
    });

    window.addEventListener('pageshow', function (event) {
      if (event.persisted) refreshCartCount();
    });

    var itemsHolder = document.querySelector('[data-cart-drawer] [data-items-holder]');
    if (itemsHolder && 'MutationObserver' in window) {
      new MutationObserver(refreshCartCount).observe(itemsHolder, { childList: true, subtree: true });
    }
  }





  /* ------------------------------------------------------------------------
     Newsletter — affichage du message « Merci de votre inscription »
     Fonctionnement natif : après l'envoi, Shopify recharge la page avec
     ?customer_posted=true et le thème (assets/newsletter-form.js) pose la
     classe .has-success sur le formulaire, ce qui affiche le message rendu par
     snippets/newsletter-form.liquid (traduction general.newsletter_form.
     newsletter_success) et masque le champ e-mail.
     Mais le thème ne le fait que si (1) l'id du formulaire a pu être mémorisé
     en sessionStorage au moment de l'envoi et (2) l'URL COMMENCE par
     ?customer_posted=true. Ce filet de sécurité couvre les autres cas
     (stockage indisponible, paramètre placé après un autre, retour depuis la
     page anti-spam...) : Shopify conserve dans l'URL le hash du formulaire
     envoyé (#NewsletterForm--id), on cible celui-là, sinon le premier
     formulaire newsletter de la page.
     ------------------------------------------------------------------------ */
  function showNewsletterSuccessFallback() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('customer_posted') !== 'true') return;
    if (document.querySelector('.newsletter-form.has-success')) return; // le thème a déjà fait le travail

    var form = null;
    var hash = window.location.hash;
    if (hash && hash.indexOf('#NewsletterForm--') === 0) {
      form = document.getElementById(hash.slice(1));
    }
    if (!form) form = document.querySelector('.newsletter-form');
    if (!form) return;

    form.classList.remove('has-error');
    form.classList.add('has-success');
  }

  if (document.querySelector('.newsletter-form')) {
    // On laisse d'abord le composant du thème s'initialiser, puis on complète si besoin.
    var newsletterReady = window.customElements
      ? customElements.whenDefined('newsletter-form')
      : Promise.resolve();
    Promise.race([newsletterReady, new Promise(function (r) { setTimeout(r, 1000); })])
      .then(function () { setTimeout(showNewsletterSuccessFallback, 0); });
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
